import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-redsys-loading-processing',
  templateUrl: './redsys-loading-processing.html',
  styleUrls: ['./redsys-loading-processing.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RedsysLoadingProcessingComponent {
  constructor() {}
}
